import apiSlice from './apiSlice';

export interface ProfitLossItem {
  id?: string;
  eventId?: string;
  marketId?: string;
  marketName?: string;
  marketType?: string;
  selectionId?: string;
  selectionName?: string;
  runnerName?: string;
  rate?: string;
  stake?: string;
  pl?: string; // Profit/Loss
  betOn?: 'BACK' | 'LAY';
  createdAt?: string;
  eventName?: string;
  matchId?: string;
  amount?: string | number;
  odds?: string | number;
  selection?: string;
  [key: string]: any;
}

export interface ProfitLossResponse {
  success?: boolean;
  message?: string;
  bets?: ProfitLossItem[];
  pagination?: Pagination;
}

export interface Pagination {
  totalItems: number;
  currentPage: number;
  limit: number;
  totalPage: number;
}

export interface CasinoProfitLossItem {
  id: number;
  gameId: number;
  gameName: string;
  roundId: string;
  txnId: string;
  userId: string;
  status: 'Won' | 'Lost' | 'Pending';
  totalBets: string;
  totalWins: string;
  totalLosses: string;
  completed: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface BetProfitLossResponse {
  success?: boolean;
  message?: string;
  bets?: ProfitLossItem[] | CasinoProfitLossItem[];
  pagination?: Pagination;
  filteredProfitLoss?: string | number;
  totalProfitLossAllSports?: string | number;
}

export interface ProfitLossQueryParams {
  page?: number;
  limit?: number;
  sport: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
}

export interface BetHistoryParams {
  page?: number;
  limit?: number;
  betTime: string;
  fromDate?: string;
  toDate?: string;
  eventId?: string;
  sport?: string;
  search?: string;
}

export const betApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBetHistory: builder.query<ProfitLossResponse, BetHistoryParams>({
      query: (params) => ({
        url: '/bet/history',
        method: 'GET',
        params: { ...params, t: Date.now() },
      }),
    }),

    getProfitLoss: builder.query<BetProfitLossResponse, ProfitLossQueryParams>({
      query: (params) => ({
        url: '/bet/profit-loss',
        method: 'GET',
        params: { ...params, t: Date.now() },
      }),
    }),
  }),
});

export const { useGetBetHistoryQuery, useGetProfitLossQuery } = betApi;
